import React from "react";
import { useHistory } from "react-router-dom";
import { Button, Row, Col } from "antd";
import styled from "styled-components";
import {
  CloudUploadOutlined,
  FormOutlined,
  CloudDownloadOutlined,
} from "@ant-design/icons";
// import Swal from "sweetalert2";

const MainDiv = styled.div`
  line-height: 200px;
  text-align: center;
`;

export const MainUploadScreen = () => {
  const history = useHistory();

  return (
    <MainDiv className="children-inner-container-with-bg">
      <Row
        gutter={[16, 16]}
        justify="center"
        style={{
          padding: "20px",
          maxWidth: "1200px",
          margin: "0 auto",
        }}
      >
        <Col xs={24} sm={12} md={12} lg={8} xl={8}>
          <Button
            type="primary"
            shape="round"
            className="upload-button"
            onClick={() => history.push("/upload-file")}
            style={{
              width: "100%",
              height: "180px",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              padding: "20px",
            }}
          >
            <CloudUploadOutlined
              style={{
                fontSize: "clamp(60px, 8vw, 100px)",
                marginBottom: "8px",
              }}
            />
            <p
              style={{
                fontSize: "clamp(16px, 2vw, 22px)",
                margin: 0,
                textAlign: "center",
                fontWeight: "500",
              }}
            >
              Cargar Excel
            </p>
          </Button>
        </Col>

        <Col xs={24} sm={12} md={12} lg={8} xl={8}>
          <Button
            type="primary"
            shape="round"
            className="upload-button"
            onClick={() => history.push("/manual-upload")}
            style={{
              width: "100%",
              height: "180px",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              padding: "20px",
            }}
          >
            <FormOutlined
              style={{
                fontSize: "clamp(60px, 8vw, 100px)",
                marginBottom: "8px",
              }}
            />
            <p
              style={{
                fontSize: "clamp(16px, 2vw, 22px)",
                margin: 0,
                textAlign: "center",
                fontWeight: "500",
              }}
            >
              Ingreso Manual
            </p>
          </Button>
        </Col>

        <Col xs={24} sm={12} md={12} lg={8} xl={8}>
          <Button
            type="primary"
            shape="round"
            className="upload-button"
            onClick={() => history.push("/manual-uploadV2")}
            style={{
              width: "100%",
              height: "180px",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              padding: "20px",
            }}
          >
            <FormOutlined
              style={{
                fontSize: "clamp(60px, 8vw, 100px)",
                marginBottom: "8px",
              }}
            />
            <p
              style={{
                fontSize: "clamp(16px, 2vw, 22px)",
                margin: 0,
                textAlign: "center",
                fontWeight: "500",
              }}
            >
              Ingreso Manual V2
            </p>
          </Button>
        </Col>

        <Col xs={24} sm={12} md={12} lg={8} xl={8}>
          <Button
            type="primary"
            shape="round"
            className="upload-button"
            onClick={() => history.push("/TMSLoad")}
            style={{
              width: "100%",
              height: "180px",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              padding: "20px",
            }}
          >
            <CloudDownloadOutlined
              style={{
                fontSize: "clamp(60px, 8vw, 100px)",
                marginBottom: "8px",
              }}
            />
            <p
              style={{
                fontSize: "clamp(16px, 2vw, 22px)",
                margin: 0,
                textAlign: "center",
                fontWeight: "500",
              }}
            >
              Sincronizar Ordenes
            </p>
          </Button>
        </Col>

        <Col xs={24} sm={12} md={12} lg={8} xl={8}>
          <Button
            type="primary"
            shape="round"
            className="upload-button"
            onClick={() => history.push("/TMSLoadV2")}
            style={{
              width: "100%",
              height: "180px",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              padding: "20px",
            }}
          >
            <CloudDownloadOutlined
              style={{
                fontSize: "clamp(60px, 8vw, 100px)",
                marginBottom: "8px",
              }}
            />
            <p
              style={{
                fontSize: "clamp(16px, 2vw, 22px)",
                margin: 0,
                textAlign: "center",
                fontWeight: "500",
              }}
            >
              Sincronizar Ordenes V2
            </p>
          </Button>
        </Col>
      </Row>
    </MainDiv>
  );
};
